const addJsonEnding = (endpoint) => `${endpoint}.json`;

export default addJsonEnding;
